export enum TaskInterventionLevelType {
  'PATIENT' = 'Patient',
  'DRUG' = 'Drug',
  'PRESCRIBER' = 'Prescriber',
  'OTHER' = 'Other',
}

export enum TaskInterventionLevelTypeClass {
  'Patient' = 'primary',
  'Drug' = 'success',
  'Prescriber' = 'danger',
  'Other' = 'info',
}
